class inputRuleCtrl {
    constructor($scope, $state, logger, httpRequest) {
        function queryList() {
            // httpRequest.post_getSysParam({ params: ['ivat_auto_confirm_invoice_flag', 'ivat_auto_proofread_flag', 'ivat_auto_receive_invoice_flag', 'ivat_auto_submit_invoice_flag'] }).then(res => {
            httpRequest.post_getSysParam({ params: ['ivat_auto_proofread_flag'] }).then((res) => {
                if (res.data.success) {
                    $scope.sysParamList = res.data.value
                    $scope.sysParamList.forEach((item) => {
                        item.name = item.remark.split('|')[0]
                        item.remarkWord = item.remark.split('|')[1]
                    })
                }
            })
        }
        queryList()
        $scope.changeStatus = function changeStatus(code, v) {
            httpRequest.post_updateSysParam([{
                paramCode: code,
                paramValue: v,
            }]).then((res) => {
                if (res.data.success) {
                    logger.logSuccess(`${v == '1' ? '启用' : '禁用'}成功`)
                    queryList()
                }
            })
        }

        // 设置
        $scope.toSettingPage = function (v) {
            if (v == 'ivat_auto_confirm_invoice_flag') {
                $state.go('system.settingcenter.inputRule.autoSelect')
            } else if (v == 'ivat_auto_proofread_flag') {
                $state.go('system.settingcenter.inputRule.proofreadRule')
            }
        }
    }
}

inputRuleCtrl.$inject = ['$scope', '$state', 'logger', 'httpRequest']
export default inputRuleCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/inputRule/inputRuleCtrl.js